import React from 'react';
import { Container, Row, Col, Form, FormGroup, Label, Input, Button, NavbarBrand, Alert } from 'reactstrap';
import Footer from '@components/Footer';

class VerificationFailure extends React.Component {
    render() {
        return (
            <div className="simple-page">
                <header className="app-header navbar">
                    <Container className="fluid">
                        <div className="fp-top">
                            <Row>
                                <Col><NavbarBrand href="https://www.corlytics.com"></NavbarBrand></Col>
                            </Row>
                        </div>
                    </Container>
                </header>
                <Container>
                    <Row>
                        <Col>
                            <div className="card">
                                <div className="card-header">Verification Failure</div>
                                <div className="card-block">
                                    <Row>
                                        <Col>
                                            Verification failure. The token is incorrect or expired.
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Footer />
            </div>
        )
    }
}

export default VerificationFailure;


// WEBPACK FOOTER //
// ./src/views/Pages/VerificationFailure/VerificationFailure.js